export default __webpack_public_path__ + "static/media/unpublished.0d6fd90c.svg";